import { Col, Row } from "react-bootstrap"

import Order from "../../../components/Order"

import * as S from "./styled"

import { cart } from "../../../i18n/pt.json"

export default function Layout({ order }) {
  return (
    <S.Wrapper className="container-fluid">
      <Row noGutters>
        <Col sm={12}>
          <S.Header>
            <S.Title>{cart.title}</S.Title>
          </S.Header>
        </Col>
      </Row>
      <Row noGutters>
        <Col sm={12}>
          <Order {...order} />
        </Col>
      </Row>
    </S.Wrapper>
  )
}
